import styled from 'styled-components';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';

export const CancelButton = styled(BaseCancelButton)`
  margin-right: 13px;
  width: 90px;
`;
CancelButton.displayName = 'CancelButton';

export const CustomBlueButton = styled(Button)`
  height: 34px;
  width: 90px;
  user-select: none;
  padding: 0px;
`;
CustomBlueButton.displayName = 'CustomBlueButton';

export const ButtonsWrapper = styled.div`
  position: absolute;
  padding: 10px;
  bottom: 0px;
  right: 0px;
  background-color: ${({ theme }) => theme.backgrounds.quaternary};
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;
ButtonsWrapper.displayName = 'ButtonsWrapper';
